export default __webpack_public_path__ + "static/media/pr.b5fc2adc.svg";